import firebase from "firebase/compat/app";
import {db} from "../firebase";
import {getUid} from "./auth";
import {Collections} from "./collections";

export const getSubmission = (gameId, studentId) => {
    if (!gameId || !studentId) return Promise.reject("no uid");

    return db
        .collection(Collections.GAMES)
        .doc(gameId)
        .collection(Collections.SUBMISSIONS)
        .doc(studentId)
        .get()
        .then((doc) => {
            if (doc.exists) return doc.data();
            else return null;
        });
}

export const getSubmissionListener = (observer, gameId, studentId) => {
    if (!gameId || !studentId) return Promise.reject("no uid");

    return db
        .collection(Collections.GAMES)
        .doc(gameId)
        .collection(Collections.SUBMISSIONS)
        .doc(studentId)
        .onSnapshot(observer);
};

// export const updateSubmission = submission => {
// 	const uid = getUid();
// 	if (!submission && !uid) return Promise.reject();

// 	const batch = db.batch();
// 	const subRef = db
// 		.collection(Collections.GAMES)
// 		.doc(submission.gameId)
// 		.collection(Collections.SUBMISSIONS)
// 		.doc(submission.studentId);

// 		batch.set(subRef, submission, { merge: true })

// 	const studentRef = db.collection(Collections.USERS).doc(uid);
// 	batch.update(studentRef, "games", firebase.firestore.FieldValue.arrayUnion({
//         id: submission.gameId,
//         rmId: submission.rmId,
// 		created: firebase.firestore.FieldValue.serverTimestamp()
//     }));

// 	return batch.commit();
// }

export const addSubmission = submission => {
    const uid = getUid();
    if (!submission && !uid) return Promise.reject();

    const batch = db.batch();
    const gameRef = db
        .collection(Collections.GAMES)
        .doc(submission.gameId);
    const subRef = gameRef
        .collection(Collections.SUBMISSIONS)
        .doc(submission.studentId);

    batch.set(subRef, submission);

    const studentRef = db.collection(Collections.USERS).doc(uid);
    batch.update(studentRef, "games", firebase.firestore.FieldValue.arrayUnion({
        id: submission.gameId,
        rmId: submission.rmId,
        created: new Date()
    }));

    return batch.commit();
}